module.exports = __webpack_public_path__ + "static/media/logofooter.39e10eff.svg";